var _defs, _rect, _path, _path2, _circle, _path3, _path4, _path5, _ellipse, _ellipse2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdeaPanel4B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 227 457",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3,.cls-4{fill:none;}.cls-2,.cls-5{fill:#fff;}.cls-2,.cls-3,.cls-4,.cls-5{stroke:#000;}.cls-2,.cls-3,.cls-4{stroke-miterlimit:10;}.cls-4,.cls-5{stroke-linecap:round;}.cls-5{stroke-linejoin:round;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 227,
    height: 457
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M128.2,256.37a15.41,15.41,0,0,0,4.88,3.48,7.14,7.14,0,0,0,5.85,0c3.42-1.77,4-6.53,3-10.25s-3.21-7.09-3.82-10.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.41,243.68a32.2,32.2,0,0,0-.7,9.72c.42,3.23,2,6.48,4.84,8.11s7,1.1,8.7-1.66"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 104.85,
    cy: 231.48,
    r: 33.49
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73.12,240.87a52.88,52.88,0,0,0,30-43.3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92.72,224.36a44,44,0,0,0,45.69,3.54"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M133.62,230.56c0,6.54.14,10.24.66,16.55"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.96,
    cy: 245.29,
    rx: 2.89,
    ry: 4.04,
    transform: "translate(-2.62 1.05) rotate(-0.61)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 117.18,
    cy: 245.08,
    rx: 2.89,
    ry: 4.04,
    transform: "translate(-2.62 1.27) rotate(-0.61)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.76,347.57l-1.37,23.85a8.6,8.6,0,0,0,10.07,9L194.32,359.5a8.61,8.61,0,0,0,4.88-14.29l-15.54-17a8.66,8.66,0,0,0-6.94-2.79,746.24,746.24,0,0,0-104.18,14.2A8.6,8.6,0,0,0,65.76,347.57Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M102.15,256.63c2.21,0,7.35-.83,11.35-.59"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M106.58,256.8a5.66,5.66,0,0,0,3.43,2.57,2.58,2.58,0,0,0,2.31-.27,1.56,1.56,0,0,0,.48-1.38,3.73,3.73,0,0,0-.53-1.41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M83.7,357.17l4.6-3.51"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M92.92,363.85l2.47-4.09"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M108.37,364.3l-2-4.66"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M167.59,350.86l-4.59-3.5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M158.38,357.54l-2.47-4.08"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M142.93,358l1.94-4.67"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M81.74,287.46a12.67,12.67,0,0,0-8.4,3.92,1.06,1.06,0,0,0-.41.9c.08.46.6.63,1,.71a56.16,56.16,0,0,0,10.46,1.31,18.7,18.7,0,0,0,10-2.58C90.73,288.2,85.53,287.25,81.74,287.46Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M76.65,291.71c0,30.44,3,40.69,14.36,55.78a44.05,44.05,0,0,0,5.46,5.72,9,9,0,0,0,6.75,2.17c4.24-.35,6-2.53,6-7,0-2.4-1.69-4.77-2.39-7.09l3.54,1a5.73,5.73,0,0,0,1.92.32,2,2,0,0,0,1.63-.92,1.93,1.93,0,0,0-.16-1.87,4.91,4.91,0,0,0-1.4-1.36c-2.46-1.81-6.44-3-9.29-4.08C87,321.3,90.61,307.37,90.61,290"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M151.31,280.5a38.56,38.56,0,0,0-9.28,2.16,13.07,13.07,0,0,0-7,6.17A44.31,44.31,0,0,0,149.35,284a6.24,6.24,0,0,0,1.8-1.29,2.42,2.42,0,0,0,.65-2.05C151.48,280.65,151.17,280.67,151.31,280.5Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M138.77,286.93c8,23.83,7.17,31.4-.56,40.23,0,0,.08-.6,0,0a16,16,0,0,0-6.72,3.78,5.37,5.37,0,0,0-1.21,1.55,2.28,2.28,0,0,0-.08,1.91,2.47,2.47,0,0,0,2.61,1.17,9,9,0,0,0,2.82-1.15c.59-.32,1.2-.61,1.82-.88,0,.69-.08,1.38-.07,2.07.05,3.42-.61,6.71,1.61,9.31s7.51,3.38,10.7,2.15c3.63-1.4,6.62-5.48,8.67-13.69a85.05,85.05,0,0,0,2-22.55c-.58-9.75-4.44-19.07-9.57-28.59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaPanel4B);
export default __webpack_public_path__ + "static/media/Idea_Panel_4b.39102fe511528868093d90aca2087f95.svg";
export { ForwardRef as ReactComponent };